import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import TrackVisibility from "react-on-screen";
import { Code, Heart, Laptop } from "react-bootstrap-icons";
import aboutImg from "../assets/img/portfolioimage.png"; // Replace with your image

export const About = () => {
  return (
    <section className="about" id="about">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeInLeft" : ""}>
                  <div className="about-image-wrapper">
                    <div className="about-image-glow"></div>
                    <div className="about-image-ring"></div>
                    <img 
                      src={aboutImg} 
                      alt="About Me" 
                      className="about-image"
                    />
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
          
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeInRight" : ""}>
                  <div className="about-content">
                    <span className="about-badge">About Me</span>
                    <h2 className="about-title">
                      Who Am I?
                    </h2>
                    <div className="about-line"></div>
                    
                    <p className="about-text">
                      My journey into development began with a curiosity about how websites work. 
                      What started as tinkering with HTML quickly became a passion for creating 
                      meaningful digital experiences. I love the challenge of turning complex problems 
                      into elegant, user-friendly solutions.
                    </p>
                    
                    <p className="about-text">
                      I believe that great code is not just about functionality—it's about creating 
                      experiences that make people's lives easier. Whether it's optimizing performance, 
                      writing clean and maintainable code, or learning new technologies, I'm always 
                      pushing myself to grow and improve.
                    </p>
                    
                    <div className="about-values">
                      <div className="value-item">
                        <Code className="value-icon" />
                        <div>
                          <h4>Clean Code</h4>
                          <p>Writing readable, maintainable, and efficient code</p>
                        </div>
                      </div>
                      <div className="value-item">
                        <Laptop className="value-icon" />
                        <div>
                          <h4>Continuous Learning</h4>
                          <p>Always exploring new technologies and best practices</p>
                        </div>
                      </div>
                      <div className="value-item">
                        <Heart className="value-icon" />
                        <div>
                          <h4>Passion Driven</h4>
                          <p>Building solutions that make a real difference</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="about-quote">
                      <span className="quote-icon">💡</span>
                      <p>"Code is not just about making things work — it's about making things possible."</p>
                    </div>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};